var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { ODRendererEventType } from '@mdpp/od-belt';
import React from 'react';
import { useColorString } from '../../../../../../hooks/useCSSStrings';
export var ODBooleanRenderer = function (props) {
    var _a = props.trueString, trueString = _a === void 0 ? 'Y' : _a, _b = props.falseString, falseString = _b === void 0 ? 'N' : _b, _c = props.trueColor, trueColor = _c === void 0 ? 'black' : _c, _d = props.falseColor, falseColor = _d === void 0 ? 'black' : _d, value = props.value, context = props.context, originalValue = props.originalValue;
    var tColor = useColorString(trueColor);
    var fColor = useColorString(falseColor);
    var handleClick = React.useCallback(function (currentValue) {
        var _a, _b;
        (_b = (_a = context).onEvent) === null || _b === void 0 ? void 0 : _b.call(_a, {
            eventType: ODRendererEventType.ChangeValue,
            valueFrom: currentValue,
            valueTo: !currentValue,
            originalValue: originalValue,
            eventKey: props.eventKey,
        }, __assign(__assign({}, context.parentContext), { renderedFromOriginalValue: originalValue }));
    }, [originalValue, context]);
    return (React.createElement("span", { style: { cursor: 'pointer', color: value ? tColor : fColor }, onClick: function () { return handleClick(value); } }, value ? trueString : falseString));
};
//# sourceMappingURL=ODBooleanRenderer.js.map